import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-2.25rem)] items-center bg-brand-main px-4 py-8 text-center md:py-10" data-id="element-86" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-87" data-mp="23xe82204an12">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-88" data-mp="30k0weybdv4dk">
          Das komplette Kunst-Curriculum
        </p>
        <h1 className="mt-3 max-w-3xl text-[1.9rem] font-extrabold leading-[1.08] tracking-tight text-brand-navy sm:text-[2.6rem] md:text-[3rem]" data-id="element-89" data-mp="2rsh0sl21lamt">
          Unterrichte ein ganzes Jahr{' '}
          <span className="font-script italic text-brand-orange" data-id="element-90" data-mp="3k91hucj1ww06">Kunst</span> in
          nur 5 Minuten Vorbereitung
        </h1>
        <p className="mx-auto mt-3 max-w-2xl text-[13px] leading-relaxed text-brand-gray sm:text-[15px]" data-id="element-91" data-mp="2fgk08zrodqpp">
          Kunst Startklar ist ein komplettes, fertiges Kunst-Curriculum — 10
          Bände voller sofort einsetzbarer Stunden, praktischer Projekte und
          Bildfolgen Schritt für Schritt, von Klasse 1 bis Klasse 10. Einfach
          ausdrucken, aufschlagen und loslegen.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/k5f8c6pEFvSWZFf8AFRW5n/ChatGPT_Image_31_ago_2026,_18_18_44-Photoroom.png" alt="Kunst Startklar Komplettpaket: 10 Bände von Klasse 1 bis 10, digitale Unterrichtsabläufe auf Bildschirm und Tablet sowie 5 Bonus-Hefte mit Malutensilien" className="mx-auto my-4 h-[34svh] w-auto max-w-full object-contain sm:my-5 sm:h-[38svh]" data-id="element-92" data-mp="2z2gauxrdhoco" />
        <CTAButton animated className="px-8 py-3.5" data-id="element-93" data-mp="1dqonb4yx0yr1" />
        <p className="mt-3 text-[11px] font-semibold text-brand-gray sm:text-xs" data-id="element-94" data-mp="18rbqbrebybaq">
          Sofort-Download <span className="px-1 text-brand-orange" data-id="element-95" data-mp="38tl13h93ahuq">·</span>{' '}
          Sichere Bezahlung <span className="px-1 text-brand-orange" data-id="element-96" data-mp="38vnwyhwxb57d">·</span> 30
          Tage Geld-zurück-Garantie
        </p>
      </motion.div>
    </section>;
}